import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const goHomeSection = (id) => {
    navigate('/');
    setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 350);
  };

  return (
    <footer className="bg-gradient-to-b from-charcoal to-charcoal-dark text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="text-3xl font-['Georgia',serif] mb-4">
              FLY OUT <span className="font-normal">by SAMANTHA</span>
            </div>
            <p className="text-gray-400 font-light leading-relaxed mb-6">
              Créateur d'expériences de voyage uniques et inoubliables, réservées aux femmes.
              Voyager autrement, entre nous. Prochaine destination : Cap-Vert 2027 · Afro Nation.
            </p>
            <div className="flex items-center gap-4">
              <a href="mailto:flyoutbysam@gmail.com" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-gold-300 transition-colors">
                <Mail className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/flyoutbysamantha" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-gold-300 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => goHomeSection('afronation-2027')}
                  className="text-gray-400 hover:text-gold-300 transition-colors font-light"
                >
                  Cap-Vert 2027
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/voyage-effectue')}
                  className="text-gray-400 hover:text-gold-300 transition-colors font-light"
                >
                  Voyage effectué
                </button>
              </li>
              <li>
                <button 
                  onClick={() => goHomeSection('contact')}
                  className="text-gray-400 hover:text-gold-300 transition-colors font-light"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-400 font-light">
              <li>
                <a href="mailto:flyoutbysam@gmail.com" className="hover:text-gold-400 transition-colors">
                  flyoutbysam@gmail.com
                </a>
              </li>
              <li>Prochain voyage : Cap-Vert 2027 · Afro Nation</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm font-light">
            © {currentYear} Fly Out By SAMANTHA.S.THETIK. Tous droits réservés.
          </p>
          <div className="flex gap-6 text-sm">
            <button className="text-gray-400 hover:text-gold-300 transition-colors font-light">
              Conditions générales
            </button>
            <button className="text-gray-400 hover:text-gold-300 transition-colors font-light">
              Politique de confidentialité
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;